query TranslationsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: TranslationsFilterInput
) {
  translations(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      project
      namespace
      version
      variants {
        languageCode
        translated
        untranslated
        total
      }
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
  }
}
